var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrailerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.939024 0C0.420416 0 0 0.420416 0 0.939024V10.1616H0.527596C0.716866 11.6371 1.97755 12.7774 3.50457 12.7774C4.59145 12.7774 5.5434 12.1998 6.07012 11.3347C6.59685 12.1998 7.5488 12.7774 8.63567 12.7774C10.1627 12.7774 11.4234 11.6371 11.6126 10.1616H12.6244L13.7165 8.68598H22V0.939024C22 0.420416 21.5796 0 21.061 0H0.939024ZM4.96341 9.77592C4.96341 10.5816 4.31027 11.2348 3.50457 11.2348C2.69888 11.2348 2.04573 10.5816 2.04573 9.77592C2.04573 8.97022 2.69888 8.31707 3.50457 8.31707C4.31027 8.31707 4.96341 8.97022 4.96341 9.77592ZM8.63567 11.2348C9.44137 11.2348 10.0945 10.5816 10.0945 9.77592C10.0945 8.97022 9.44137 8.31707 8.63567 8.31707C7.82998 8.31707 7.17683 8.97022 7.17683 9.77592C7.17683 10.5816 7.82998 11.2348 8.63567 11.2348Z",
    fill: "#A9BAC8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerIcon);
export default __webpack_public_path__ + "static/media/TrailerIcon.b61b333f3d86a184d2893863876bf414.svg";
export { ForwardRef as ReactComponent };